import * as r from 'ramda';

export default class SubscriptionManager {
  subs = [];

  push(unsubFunction) {
    if (unsubFunction) {
      if (typeof unsubFunction !== 'function') {
        throw new Error("Not an unsub function: " + unsubFunction);
      }
      this.subs.push({
        fn: unsubFunction
      })
    } else {
      console.log("Warning: no unsub function.", new Error().stack);
    }
  }

  watch(filter, handler) {
    var w = filter.watch(handler);
    this.subs.push({
      fn: () => w.stopWatching(() => {})
    });
  }

  subscribeEvent(target, event, handler) {
    target.on(event, handler);
    this.subs.push({
      fn: () => target.off(event, handler),
      handler,
      target
    })
  }

  subscribe(service, handler) {
    this.push(service.subscribe(handler));
  }

  unsubscribe(target, event) {
    if (!target && !event) {
      this.subs.forEach(sub => sub.fn());
      this.subs = [];
    } else {
      var found = r.find(r.both(r.propEq('target', target), r.propEq('event',event)),this.subs)
      if (found) {
        found.fn();
        this.subs = r.without([found], this.subs)
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/SubscriptionManager.js